import { render, staticRenderFns } from "./ModalQueueDids.vue?vue&type=template&id=248fd89a&"
import script from "./ModalQueueDids.vue?vue&type=script&lang=ts&"
export * from "./ModalQueueDids.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports